import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchCompanyMetrics } from '../queries/MaggieMetricsQueries';

export interface CompanyMetricsQueryParams {
  companyId: number;
  asOfDate?: string;
  currency?: string;
}

/** Query key factory for type safety and consistency */
export const companyMetricsQueryKeys = {
  all: ['companyMetrics'] as const,
  byId: (params: CompanyMetricsQueryParams) => [...companyMetricsQueryKeys.all, params] as const,
};

/** Query options factory - can be used with useQuery, useSuspenseQuery, or prefetching */
export const companyMetricsQueryOptions = (params: CompanyMetricsQueryParams) =>
  queryOptions({
    queryKey: companyMetricsQueryKeys.byId(params),
    queryFn: () => fetchCompanyMetrics(params.companyId, params.asOfDate, params.currency, true),
    enabled: Boolean(params.companyId),
  });

/** Hook for fetching company metrics by ID */
export const useCompanyMetricsById = (params: CompanyMetricsQueryParams) => {
  return useQuery(companyMetricsQueryOptions(params));
};
